<template>
  <div class="collections-container">
    <div class="collections-list" v-if="!isDataLoading">
      <CollectionCard
        v-for="collection in currentCollections"
        :key="collection.collectionId"
        :collection="collection"
        :thumbs="collection.thumbs"
        @click="openCollection(collection)"
      />
    </div>
    <CardsListSkeletonLoader v-else />
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';

import useCollections from '~/composables/useCollections';
import CollectionCard from '~/components/conversation/collections/CollectionCard';
import CardsListSkeletonLoader from '~/components/conversation/sidepanelGeneralComponents/CardsListSkeletonLoader';
import useConversations from '~/composables/useConversations';

export default {
  props: {
    currentCollections: {
      type: Array,
      default: () => [],
    },
  },
  components: { CollectionCard, CardsListSkeletonLoader },
  setup(props) {
    const { setThumbsCollectionsView } = useCollections();
    const { conversationScope, setConversationScope } = useConversations();
    const collection = ref({});

    const isDataLoading = ref(false);
    const isCreateCollectionPopupOpened = ref(false);

    const openCollection = (collection) => {
      const breadcrumb = [...conversationScope.value.breadcrumb, { title: ` ${collection.collectionName} ` }];
      setConversationScope({ isScoped: true, collection, breadcrumb });
    };

    onMounted(async () => {
      isDataLoading.value = true;
      await setThumbsCollectionsView(props.currentCollections, 5);
      isDataLoading.value = false;
    });

    return {
      collection,
      isCreateCollectionPopupOpened,
      isDataLoading,
      openCollection,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.collections-container {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);
  flex-direction: column;
  align-items: center;
  overflow: auto;
  width: 100%;
  background-color: $bb-neutral-6;

  .collections-list {
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-4;
    width: 100%;
    padding: $bb-spacing-2 $bb-spacing-4;
  }
}
</style>
